var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCellPhone = function SvgCellPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.62891 0.673171L1.96224 0.666504C1.22891 0.666504 0.628906 1.2665 0.628906 1.99984V13.9998C0.628906 14.7332 1.22891 15.3332 1.96224 15.3332H8.62891C9.36224 15.3332 9.96224 14.7332 9.96224 13.9998V1.99984C9.96224 1.2665 9.36224 0.673171 8.62891 0.673171ZM8.62891 12.6665H1.96224V3.33317H8.62891V12.6665Z"
  })));
};
export default SvgCellPhone;